import { handleActions, combineActions } from 'redux-actions'
import { Record, Map, List } from 'immutable'

import * as actions from './actions'

import { IGlobalValues } from './interface'

export const GlobalValues = Record<IGlobalValues>({
  items: List(),
  isPending: false,
})

const handleRequest = (state: Record<IGlobalValues>) => {
  return state.set('isPending', true)
}

const handleFetchSuccess = (state: Record<IGlobalValues>, { payload: { data } }: any) => {
  return state.set('items', List(data.map((el: any) => Map(el)))).set('isPending', false)
}

const handlePostSuccess = (state: Record<IGlobalValues>, { payload: { data } }: any) => {
  return state.set('items', state.get('items').push(Map(data))).set('isPending', false)
}

const handlePutSuccess = (state: Record<IGlobalValues>, { payload: { data } }: any) => {
  const index = state.get('items').findIndex(el => el.get('id') === data.id)
  return state.setIn(['items', index], Map(data)).set('isPending', false)
}

const handleDeleteSuccess = (state: Record<IGlobalValues>, { meta: { labelId } }: any) => {
  const index = state.get('items').findIndex(el => el.get('id') === labelId)
  return state.deleteIn(['items', index]).set('isPending', false)
}

const handleFail = (state: Record<IGlobalValues>) => {
  return state.set('isPending', false)
}

export default handleActions(
  {
    [combineActions(
      actions.fetchGlobalValues,
      actions.createGlobalValue,
      actions.updateGlobalValue,
      actions.deleteGlobalValue
    ) as any]: handleRequest,
    [combineActions(
      actions.fetchGlobalValues.fail,
      actions.createGlobalValue.fail,
      actions.updateGlobalValue.fail,
      actions.deleteGlobalValue.fail
    ) as any]: handleFail,
    [actions.fetchGlobalValues.success as any]: handleFetchSuccess,
    [actions.createGlobalValue.success as any]: handlePostSuccess,
    [actions.updateGlobalValue.success as any]: handlePutSuccess,
    [actions.deleteGlobalValue.success as any]: handleDeleteSuccess,
  },
  new GlobalValues()
)
